import * as t from "io-ts";
import { nullable, placeT } from "./index";
import optional from "./optional";
const trailerT = t.strict({
    id: t.string,
    number: t.string,
    alias: nullable(t.string),
});
const stopT = t.strict({
    city: nullable(t.string),
});
const routeCargoStopForPublicApiT = t.strict({
    id: t.string,
    cargoId: t.string,
    stopId: t.string,
    type: t.literal("CARGO_STOP"),
});
const routeWaypointForPublicApiT = t.strict({
    id: t.string,
    type: t.literal("WAYPOINT"),
    waypointType: t.union([
        t.literal("AUTO_FIRST_STOP"),
        t.literal("MANUAL"),
        t.literal("FROM_START_ACTIVITY"),
        t.literal("FROM_END_ACTIVITY"),
    ]),
    shouldShowToDriver: t.boolean,
    note: nullable(t.string),
    place: placeT,
});
const routeStopForPublicApiT = t.union([
    routeCargoStopForPublicApiT,
    routeWaypointForPublicApiT,
]);
const routeStopsForPublicApiT = t.array(routeStopForPublicApiT);
const routeForPublicApiT = t.strict({
    id: t.string,
    routeName: nullable(t.string),
    trailerId: nullable(t.string),
    unpoweredTrailerId: nullable(t.string),
    destinationDate: nullable(t.string),
    createdAt: optional(t.string),
    cargoOrder: t.array(t.string),
    drivers: t.array(t.string),
    stops: routeStopsForPublicApiT,
    firstStop: stopT,
    lastStop: stopT,
});
const routeT = t.intersection([
    routeForPublicApiT,
    t.strict({
        completed: t.boolean,
    })
]);
export const getDriverRoutesResponseT = t.array(routeT);
export const getDriverRoutesResponseForPublicApiT = t.array(routeForPublicApiT);
export const getTrailersAndRoutesResponseT = t.strict({
    trailers: t.array(trailerT),
    unpoweredTrailers: t.array(trailerT),
    routes: getDriverRoutesResponseT,
});
export const getTrailersAndRoutesResponseForPublicApiT = t.strict({
    trailers: t.array(trailerT),
    routes: t.array(routeForPublicApiT),
});
//# sourceMappingURL=mobile-app-routes-and-trailers.js.map